export function countReducer(
  sum: number,
  { count = 0 }: CountReducerCount,
  _i: number,
  _counts: CountReducerCount[]
) {
  return sum + count
}

interface CountReducerCount {
  count?: number
}
